/**
 * Whether a subscription is currently an active partner grant (i.e. protected
 * from auto-downgrade). Mirrors the backend `isPartnerPlanLocked`: active while
 * `isPartner` is true and there is no expiry (indefinite) or the expiry is still
 * in the future. An unparseable expiry is treated as active (safe default).
 */
export function isPartnerActive(
  { isPartner, expiresAt }: { isPartner: boolean; expiresAt: string | null },
  now: Date,
): boolean {
  if (!isPartner) return false;
  if (!expiresAt) return true;
  const t = new Date(expiresAt).getTime();
  if (Number.isNaN(t)) return true;
  return t > now.getTime();
}
